import defaultAnimation1Src from "./assets/default-animation-1.webm";
import defaultAnimation2Src from "./assets/default-animation-2.webm";
import defaultAnimation3Src from "./assets/default-animation-3.webm";
import defaultAnimation4Src from "./assets/default-animation-4.webm";
import defaultAnimation5Src from "./assets/default-animation-5.webm";
import defaultAnimation6Src from "./assets/default-animation-6.webm";
import defaultAnimation7Src from "./assets/default-animation-7.webm";
import defaultAnimation8Src from "./assets/default-animation-8.webm";
import defaultAnimation9Src from "./assets/default-animation-9.webm";

import defaultRecording1Src from "./assets/default-recording-1.webm";
import defaultRecording2Src from "./assets/default-recording-2.webm";
import defaultRecording3Src from "./assets/default-recording-3.webm";

export interface DefaultCTAVisual {
  id: string;
  src: string;
}

const DEFAULT_CTA_VISUALS_DICT: Record<string, Omit<DefaultCTAVisual, "id">> = {
  // Emoji-like animations
  "default-1": { src: defaultAnimation1Src },
  "default-2": { src: defaultAnimation2Src },
  "default-3": { src: defaultAnimation3Src },
  "default-4": { src: defaultAnimation4Src },
  "default-5": { src: defaultAnimation5Src },
  "default-6": { src: defaultAnimation6Src },
  "default-7": { src: defaultAnimation7Src },
  "default-8": { src: defaultAnimation8Src },
  "default-9": { src: defaultAnimation9Src },

  // Realistic recordings
  "default-recording-1": { src: defaultRecording1Src },
  "default-recording-2": { src: defaultRecording2Src },
  "default-recording-3": { src: defaultRecording3Src },
};

export const getDefaultCTAVisual = (id: string): DefaultCTAVisual => {
  const matchingVisual =
    DEFAULT_CTA_VISUALS_DICT[id as keyof typeof DEFAULT_CTA_VISUALS_DICT];

  if (!matchingVisual) {
    return {
      id: "default-1",
      ...DEFAULT_CTA_VISUALS_DICT["default-1"],
    };
  }

  return {
    id,
    ...matchingVisual,
  };
};

export const defaultCTAVisualList = Object.keys(
  DEFAULT_CTA_VISUALS_DICT
).reduce<DefaultCTAVisual[]>((acc, key) => {
  acc.push({
    id: key,
    ...DEFAULT_CTA_VISUALS_DICT[key as keyof typeof DEFAULT_CTA_VISUALS_DICT],
  });

  return acc;
}, []);
